
export default {
  print: {
    print: 'Imprimir',
    segment: 'Segmento',
    preparingPrinting: 'Preparando la impresión',
    readyToPrint: 'Listo para imprimir'
  }
}
